export class ChangePassword {
  public OldPassword?: string;
  public NewPassword?: string;
  public comparePassword?: string;
}
